// File: frontend/src/components/marketing/SkipToContent.js
//
// "Skip to main content" for keyboard users on the public pages. It stays off
// screen until it receives focus, and it must be the first focusable element,
// so each public shell renders it before its header.

import React from "react";
import { Box } from "@mui/material";

export const MAIN_CONTENT_ID = "main-content";

export default function SkipToContent() {
  return (
    <Box
      component="a"
      href={`#${MAIN_CONTENT_ID}`}
      sx={{
        position: "absolute",
        left: 12,
        top: -200,
        zIndex: (t) => t.zIndex.tooltip,
        px: 2,
        py: 1.25,
        borderRadius: 2,
        bgcolor: "background.paper",
        color: "text.primary",
        fontWeight: 700,
        fontSize: 14,
        textDecoration: "none",
        border: "2px solid",
        borderColor: "primary.main",
        "&:focus": { top: 12 },
      }}
    >
      Skip to main content
    </Box>
  );
}
